import { CreditCardTransactionResponse } from 'vopay';
import { useState } from 'react';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useFetchCreditCardTransaction() {
  const [fetching, setFetching] = useState(false);
  const [creditCardTransaction, setCreditCardTransaction] = useState<CreditCardTransactionResponse>();

  async function fetchCreditCardTransaction(transactionId: string, bearer?: string) {
    try {
      setFetching(true);

      const res = await api.fetchCreditCardTransaction({ TransactionID: transactionId }, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      setCreditCardTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, creditCardTransaction, fetchCreditCardTransaction };
}
